<div class="flex h-full flex-col gap-2" *transloco="let t">
  <div class="flex flex-col gap-2 px-4 pt-4">
    @if (isTacosAndVendor()) {
      <IAlert type="warning" [title]="t('tacos-strategy.no_tacos_vendor')" />
    } @else if (campaignType === CampaignType.DSP) {
      <app-overdue-amazon-invoice-warning withLinkToInvoicePage></app-overdue-amazon-invoice-warning>
      <IAlert
        type="info"
        class="mb-4"
        [title]="t('dsp-strategy-page.beta_testing_warning', { maxStrategies: maxDspStrategies })"
      />
    }
    @if (!accountMarketplace().hasAccessToAdvertising) {
      <IAlert type="warning" [title]="t('strategy-list.issue_connecting')" />
    }
    @if (!accountMarketplace().activated) {
      <IAlert type="warning" [title]="t('strategy-table.warning')">
        {{
          t("billing-account-selection.unable_to_automate", {
            amazonAdvertisingConsole: t("common.amazon_advertising_console"),
          })
        }}
        <a class="link" [href]="'https://advertising.amazon.com/'" target="_blank">
          <IIcon name="link" />
          {{ t("common.see_more") }}
        </a>
      </IAlert>
    }
    @switch (sbStrategyLimitWarning()) {
      @case (StrategyLimitWarning.REACHED) {
        <IAlert type="warning" [title]="t('strategy-list.maximum_reached_150_active_sponsored')" />
      }
      @case (StrategyLimitWarning.SOON) {
        <IAlert type="warning" [title]="t('strategy-list.reached_maximum_num', [liveStrategies()!.length])" />
      }
    }
  </div>
  @if (!isMarketplaceSupportedForCampaignType()) {
    <IAlert
      type="warning"
      [title]="t('strategy-list.campaign_type_not_supported', [campaignType, marketplace().name])"
    />
  } @else if (accountMarketplace().activated && !isTacosAndVendor()) {
    <app-strategy-grid class="flex-1" />
  }
</div>
